const DEFAULT_PRICE_ALERT_DROP_PERCENT = 10

export function priceAlertDefaultsFromCurrentPrice(
  price: number | null | undefined
) {
  if (typeof price !== "number" || !Number.isFinite(price) || price <= 0) {
    return { targetPrice: "", targetPercent: "" }
  }

  const targetPrice = Math.floor(
    price * (1 - DEFAULT_PRICE_ALERT_DROP_PERCENT / 100)
  )
  if (targetPrice <= 0) return { targetPrice: "", targetPercent: "" }

  return {
    targetPrice: String(targetPrice),
    targetPercent: String(DEFAULT_PRICE_ALERT_DROP_PERCENT),
  }
}
